import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      lookupQuerystring: "lang",
    },
    fallbackLng: "pt_br",
    debug: true,
    resources: {
      en_us: {
        translations: require("./locales/en_us/translations.json"),
      },
      es_co: {
        translations: require("./locales/es_co/translations.json"),
      },
      pt_br: {
        translations: require("./locales/pt_br/translations.json"),
      },
      pt_pt: {
        translations: require("./locales/pt_pt/translations.json"),
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

i18n.languages = ["pt_br", "pt_pt", "es_co", "en_us"];

export default i18n;
